$(document).ready(function () {
  const swiperContainer = document.querySelector(
    ".shop-category__swiper.swiper"
  );
  if (!swiperContainer) return;

  let swiper = null;
  const breakpoint = 767;

  function cleanSwiperDOM() {
    swiperContainer.classList.remove("swiper-initialized");
    swiperContainer.classList.remove("swiper-horizontal");

    swiperContainer
      .querySelectorAll(".swiper-wrapper, .swiper-slide")
      .forEach(el => {
        el.removeAttribute("style");
      });

    const pagination = swiperContainer.querySelector(".swiper-pagination");
    if (pagination) pagination.innerHTML = "";
  }

  function toggleNavigation(show) {
    document
      .querySelectorAll(
        ".shop-category-swiper-button-next, .shop-category-swiper-button-prev"
      )
      .forEach(btn => {
        btn.style.display = show ? "" : "none";
      });
  }

  function initOrDestroySwiper() {
    if (window.innerWidth > breakpoint) {
      if (!swiper) {
        swiper = new Swiper(swiperContainer, {
          slidesPerView: "auto",
          spaceBetween: 0,
          loop: false,
          navigation: {
            nextEl: ".shop-category-swiper-button-next",
            prevEl: ".shop-category-swiper-button-prev"
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          keyboard: {
            enabled: true
          }
        });

        toggleNavigation(true);
      }
    } else {
      if (swiper) {
        swiper.destroy(true, true);
        swiper = null;

        cleanSwiperDOM();
        toggleNavigation(false);
      }
    }
  }

  initOrDestroySwiper();
  window.addEventListener("resize", initOrDestroySwiper);
});
